import * as React from "react"
import { Check, ChevronsUpDown } from "lucide-react"

import { cn } from "../../lib/utils"
import { Button } from "./button"
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./command"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "./popover"

export function Combobox({ options, value, onChange, placeholder = "Select option...", className, allowArbitraryInput = false }) {
  const [open, setOpen] = React.useState(false)
  const [inputValue, setInputValue] = React.useState("")

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={cn("w-full justify-between bg-white text-left font-normal", className)}
        >
          {value || placeholder}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className={cn("p-0", className)} align="start">
        <Command>
          <CommandInput 
            placeholder="Search or type..." 
            value={inputValue}
            onValueChange={setInputValue}
          />
          <CommandList className="max-h-[250px]">
            <CommandEmpty>
              {allowArbitraryInput && inputValue ? (
                <div 
                  className="px-4 py-2 text-sm cursor-pointer hover:bg-slate-100"
                  onClick={() => {
                    onChange(inputValue.toUpperCase());
                    setOpen(false);
                    setInputValue("");
                  }}
                >
                  Create "{inputValue}"
                </div>
              ) : (
                "No results found."
              )}
            </CommandEmpty>
            <CommandGroup>
              {options.map((option) => (
                <CommandItem
                  key={option.value}
                  value={option.value}
                  onSelect={(currentValue) => {
                    // Shadcn cmdk lowercases the value on select, so we need to grab the original option.value
                    // to respect capitalization (like HP, Apple, etc.)
                    const originalValue = option.value;
                    onChange(originalValue === value ? "" : originalValue);
                    setOpen(false);
                  }}
                >
                  <Check
                    className={cn(
                      "mr-2 h-4 w-4",
                      value === option.value ? "opacity-100" : "opacity-0"
                    )}
                  />
                  {option.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
